import styled from 'styled-components';
import HomePageGeneratorInputSection from '../HomePageGenerator/HomePageGeneratorInputSection';
import { TitleTextWithGradient } from './CommonComponents';
import { SectionSeparator } from './SectionSeparator';
import { SECONDARY_TEXT_COLOR } from '../../constants';
import { FaArrowDown } from 'react-icons/fa6';
import { mobileMediaQuery } from '../../styleHelpers';

const InputBoxInLandingPage: React.FC = () => {
  return (
    <OuterContainer>
      <SectionSeparator />
      <Container>
        <EmptySpace />
        <TitleTextWithGradient marginBottom={16}>
          Try below, no signup <ArrowDownIcon />
        </TitleTextWithGradient>
        <Subtext>
          Write anything below to create an image, or choose 💬 to start a chat
        </Subtext>
        <HomePageGeneratorInputSection inLandingPage />
      </Container>
    </OuterContainer>
  );
};

export default InputBoxInLandingPage;

const OuterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 600px;

  margin-bottom: 60px;

  ${mobileMediaQuery} {
    margin-top: -44px;
  }
`;

const Subtext = styled.div`
  color: ${SECONDARY_TEXT_COLOR};
  margin-bottom: 16px;
  padding-left: 8px;
  padding-right: 8px;
`;

const EmptySpace = styled.div`
  height: 60px;
`;

const ArrowDownIcon = styled(FaArrowDown)`
  font-size: 28px;
  margin-bottom: -2px;
`;
